import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const HeartToSoul = require("../../Assets/Images/HeartToSoul.png");
const heartToStrength = require("../../Assets/Images/HeartToStrength.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
    padding: "20px",
  },
  maincontent: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#426B88",
    marginBottom: "5px",
  },
  topSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "flex-start",
  },
  coverTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
    textTransform: "uppercase",
  },
  contentContainer: {
    textAlign: "left",
    marginTop: "20px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "20px"
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "18px",
    color: "#426B88",
    lineHeight: "30px",
    marginBottom: "5px",
  },
  coverImage: {
    width: "220px",
  },
  textContent: {
    width: "60%",
    marginLeft: "25px",
    marginTop: "10px"
  },
  pointsContainer: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  pointsHeader: {
    fontWeight: "700",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    marginBottom: "5px",
  },
  pointText: {
    fontWeight: "400",
    fontSize: "12px",
    color: "#245775",
    marginBottom: "3px",
    lineHeight: "18px",
  },
  bottomSection: {
    alignItems: "center",
    marginTop: "20px",
  },
  bottomImage: {
    width: "406px",
    height: "96px",
  },
  text: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    marginTop: "10px",
  },
  noteContainer: {
    marginTop: 5,  
    padding: "10% 10% 0 10%",
    justifyContent: "center",
    alignItems: "center",
  },
  
  noteBold: {
    fontSize: 12,
    fontWeight: 700, 
    color: "#245775",
  },
  
  noteText: {
    fontSize: 12,
    fontWeight: 400, 
    color: "#426B88", 
    lineHeight: 2,  
    textAlign: "center",
    justifyContent: "center",  
    letterSpacing: 0,  
  },
});

const GroupQuadrantFlowHeartToSoul3 = () => {
  return (
    <View style={styles.coverSection}>
      {/* HEADER */}
      <Text style={styles.maincontent}>Group Results:</Text>

      {/* TOP SECTION */}
      <View style={styles.topSection}>
        <Image src={HeartToSoul} style={styles.coverImage} />
        <View style={styles.textContent}>
          <Text style={styles.coverTitle}>Soul TO HEART GROUPS</Text>
          <Text style={styles.highlightText}>
            This is meaningful; let’s feel it.
          </Text>

          {/* POTENTIAL STRENGTHS */}
          <View style={styles.pointsContainer}>
            <Text style={styles.pointsHeader}>POTENTIAL STRENGTHS</Text>
            <Text style={styles.pointText}>
              {" "}
              • Authentic and Supportive Presence{" "}
            </Text>
            <Text style={styles.pointText}>
              • Advocates for Qualitative Metrics{" "}
            </Text>
            <Text style={styles.pointText}>
              • Contemplative and Considerate
            </Text>
          </View>
        </View>
      </View>

      {/* POTENTIAL WEAKNESSES */}
      <View style={styles.contentContainer}>
        <Text style={styles.pointsHeader}>POTENTIAL WEAKNESSES</Text>
        <Text style={styles.pointText}>•Slow Decision-Making</Text>
        <Text style={styles.pointText}> • Overpowered by Competitive Environments </Text>
        <Text style={styles.pointText}> • Impractical and Emotionally Complex  </Text>
        <Text style={styles.paragraph}>
        Soul-to-Heart groups prioritize presence, relational depth, and meaningful connections. With an innate ability to connect emotionally, they inspire trust and loyalty through their genuine, authentic nature. They navigate life thoughtfully, seeing beyond the surface.
        </Text>
        <Text style={styles.paragraph}>
        However, they may struggle in environments that value speed, competition, and strategy over depth and authenticity.
        </Text>
      </View>

      {/* BOTTOM SECTION */}
      <View style={styles.bottomSection}>
        <Image src={heartToStrength} style={styles.bottomImage} />
      </View>

      <View style={styles.noteContainer}>
        <Text>
          <Text style={styles.noteBold}>Note:</Text>
          <Text style={styles.noteText}>
            {" "}
            Your group exhibits an equal flow between the Heart and Soul
            quadrants, moving seamlessly in both directions.
          </Text>
        </Text>
      </View>
    </View>
  );
};

export default GroupQuadrantFlowHeartToSoul3;
